<template>
  <mu-card id="profileAvatar" v-if="profile">
    <mu-card-text>
      <mu-raised-button
        class="followBtn"
        fullWidth
        v-cloak
        v-if="!isOwner"
        primary
        :label="isProcessFollowing ? 'Processing' : profile.auth_user_following ? 'Following' : 'Follow'"
        :disabled="isProcessFollowing"
        @click.native="follow()"
      >
        <mu-circular-progress v-if="isProcessFollowing" :size="24" color="white" />
      </mu-raised-button>
      <p class="birthday" v-if="showPrivacyInfo && isBirthday">
        <mu-icon value="cake"/>
        Happy Birthday!!
      </p>
      <p class="diabetesType" v-if="showPrivacyInfo && profile.diabetes_type" v-text="profile.diabetes_type"></p>
      <p class="bio preWrap" v-if="showPrivacyInfo && profile.bio" v-text="profile.bio"></p>
      <profile-goals />
      <div class="emptyFields" v-if="isOwner">
        <div class="field" v-for="field, fieldIndex in metaFields" :key="`meta-field-${fieldIndex}`">
          <div @click="doMetaField(field)" v-if="field.to === undefined">
            <mu-icon value="add"/>
            <span v-text="field.label"></span>
          </div>
          <!-- <div v-if="field.to" @click="goTo(field.to)">
            <mu-icon value="add"/>
            <span v-text="field.label"></span>
          </div> -->
          <add-profile-bio
            v-if="field.key === 'bio' && field.toggle"
            @bioClosed="onClose">
          </add-profile-bio>

          <add-profile-picture
            v-if="field.key === 'avatar' && field.toggle"
            @pictureClosed="onClose">
          </add-profile-picture>

          <div v-if="field.key === 'remove-avatar' && profile.profile_image" @click="removeProfilePicture()">
            <mu-icon value="remove"/>
            <span v-text="field.label"></span>
          </div>

          <add-profile-cover
            v-if="field.key === 'cover' && field.toggle"
            @coverClosed="onClose">
          </add-profile-cover>
          <div v-if="field.key === 'remove-cover' && profile.cover_photo" @click="removeCoverPhoto()">
            <mu-icon value="remove"/>
            <span v-text="field.label"></span>
          </div>
        </div>
      </div>
    </mu-card-text>
    <mu-divider v-if="!showProfileInfo" />
    <mu-menu v-if="!showProfileInfo" desktop>
      <mu-menu-item
        v-if="showPrivacyInfo"
        @click.native="goTo('ProfileFollowers')"
        :title="$t('message.labelFollowers')"
        :afterText="'' + profile.followers + ''"
      />
      <mu-menu-item
        v-if="showPrivacyInfo"
        @click.native="goTo('ProfileFollowing')"
        :title="$t('message.labelFollowing')"
        :afterText="'' + profile.following + ''"
      />
      <mu-menu-item
        v-if="showPrivacyQuestions"
        @click.native="goTo('ProfileDiscussion')"
        :title="$t('message.labelQuestionsAnswered')"
        :afterText="''+ profile.answers +''"
      />
      <mu-menu-item
        v-if="showPrivacyQuestions"
        @click.native="goTo('ProfileDiscussion')"
        :title="$t('message.labelQuestionsAsked')"
        :afterText="''+ profile.questions +''"
      />
    </mu-menu>
    <mu-divider/>


    <div id="profileProgress">
      <p>{{$t('message.labelProgramProgress')}}</p>
      <mu-row :gutter="false">
        <mu-col width="80" tablet="80" desktop="80">
          <mu-linear-progress mode="determinate" :size="15" :value="profile.progress.percentage" :min="0" :max="100"
                              :color="profile.progress.colour"/>
        </mu-col>
        <mu-col width="15" tablet="15" desktop="15">
          <span class="percentage" v-text="`${profile.progress.percentage}%`"></span>
        </mu-col>
      </mu-row>
    </div>
  </mu-card>
</template>

<script>
  import ProfileApi from '../../../api/Profile'

  import AddProfileBio from "../AddProfileBio/AddProfileBio";
  import AddProfileCover from "../AddProfileCover/AddProfileCover.vue";

  import ProfileMixin from "../../../mixins/ProfileMixin"
  import ProfileGoals from "../../../components/Profile/ProfileGoals/ProfileGoals.vue"
  import AddProfilePicture from "../AddProfilePicture/AddProfilePicture.vue";

  export default {
    components: {
      AddProfilePicture,
      AddProfileCover,
      AddProfileBio,
      ProfileGoals,
    },
    mixins: [
      ProfileMixin
    ],
    name: 'profile-avatar',
    props: {
      profile: {
        type: Object
      }
    },
    data() {


      /**
       labelFollowers: "Followers",
       labelFollowing: "Following",
       labelUpdateBio: "Update bio",
       labelEnterBio: "Enter bio",
       labelChangeProfilePicture: "Change profile picture",
       labelRemoveProfilePicture: "Remove profile picture",
       labelAddCoverPhoto: "Add cover photo",
       labelUpdateCoverPhoto: "Update cover photo",
       labelQuestionsAnswered: "Questions answered",
       labelQuestionsAsked: "Questions asked",
       labelProgramProgress: "Program progress",
       **/
      return {
        metaFields: [
          {
            key: "bio",
            label: !this.profile.bio ? this.$t('message.labelEnterBio') : this.$t('message.labelUpdateBio'),
            toggle: false
          },
          {
            key: "avatar",
            label: this.$t('message.labelChangeProfilePicture'),
            toggle: false,
          },
          {
            key: "remove-avatar",
            label: this.$t('message.labelRemoveProfilePicture'),
            toggle: false,
            to: "remove-avatar"
          },
          {
            key: "cover",
            label: !this.profile.cover_photo ? this.$t('message.labelAddCoverPhoto') : this.$t('message.labelUpdateCoverPhoto'),
            toggle: false,
          },
           {
            key: "remove-cover",
            label: this.$t('message.labelRemoveCoverPhoto'),
            toggle: false,
            to: "remove-cover"
          }
        ],
        isProcessFollowing: false,
      }
    },
    mounted() {
      let self = this;
    },
    methods: {
      onClose(field) {
        let self = this;
        let data = _.find(self.metaFields, (meta) => {
          if(meta.key === field) {
            meta.toggle = false;
          }
        });
      },
      onCoverPhotoUpdated(url) {
        this.$EventBus.$emit('CoverPhotoUpdated', url);
      },
      goTo(name) {
        let self = this;
        self.$router.push({
          name: name,
        })
      },
      follow() {
        let self = this;
        self.isProcessFollowing = true;
        ProfileApi.follow({follow_id: self.profile.user_id}).then((response) => {
          let callback = response.data;
          self.isProcessFollowing = false;
          if (callback.complete) {
            if (callback.isFollowing) {
              self.profile.auth_user_following = true;
              self.profile.followers += 1;
            } else {
              self.profile.auth_user_following = false;
              self.profile.followers -= 1;
            }
          }
        }).catch((error) => {
          self.isProcessFollowing = false;
          self.$toastr.error(error.response.data.message);
        });
      },
      doMetaField(field) {
        if (field.toggle === true) {
          field.toggle = false;
        } else {
          field.toggle = true;
        }
      },
      removeProfilePicture() {
        let self = this;
        self.$alert({
          title: "Are you sure?",
          text: "You are about to remove your profile picture",
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
        })
        .then(() => {
          self.deleteProfilePicture();
        }).catch(() => {

        })
      },
      deleteProfilePicture() {
        const self = this;
        ProfileApi.deleteProfilePicture().then((res) => {
          self.$store.state.user.scope.profile_large = null;
          self.$store.state.activeProfileObject.information.basic.profile_image = null;

        }).catch((err) => {
        })
      },
      removeCoverPhoto() {
        let self = this;
        self.$alert({
          title: "Are you sure?",
          text: "You are about to remove your cover photo",
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
        })
        .then(() => {
          self.deleteCoverPhoto();
        }).catch(() => {

        })
      },
      deleteCoverPhoto() {
        const self = this;
        ProfileApi.deleteCoverPhoto().then((res) => {
          self.$store.state.activeProfileObject.information.basic.cover_photo = null;
          self.$store.state.user.cover_photo = null;

        }).catch((err) => {

        })
      }
    },
    computed: {
      showProfileInfo() {
        let self = this;
        return !self.showPrivacyInfo && !self.showPrivacyQuestions;
      }
    }
  }

</script>



// WEBPACK FOOTER //
// ProfileAvatar.vue?8251b89e